// import { getSelectables } from "./getSelectables";
// import { getApplyReadOnly } from "./getApplyReadOnly";
// import { getSelectablesFromTable } from "./getSelectablesFromTable";

export function getProjectSchema() {
  // var schema = \\await getFeatures("schemas", "tableName", tablename);
  var schema = [
    {
      name: "id",
      default: "",
      nullable: false,
      type: "string",
      maxLength: 80,
      selectables: [],
      readOnly: true,
      helperText: "",
      error: false,
    },
    {
      name: "uid",
      default: "",
      nullable: false,
      type: "string",
      maxLength: 80,
      selectables: [],
      readOnly: true,
      helperText: "",
      error: false,
    },
    {
      name: "Name",
      default: "",
      nullable: false,
      type: "string",
      maxLength: 80,
      selectables: [],
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Short Name",
      default: "",
      nullable: false,
      type: "string",
      maxLength: 15,
      selectables: [],
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Address",
      default: "",
      nullable: false,
      type: "address",
      maxLength: 180,
      selectables: [],
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "map",
      default: "",
      nullable: false,
      type: "address",
      maxLength: 180,
      selectables: [],
      readOnly: true,
      helperText: "",
      error: false,
    },
    {
      name: "placeId",
      default: "",
      nullable: true,
      type: "string",
      maxLength: 500,
      selectables: [],
      readOnly: true,
      helperText: "",
      error: false,
    },
    {
      name: "latlon",
      default: "",
      nullable: true,
      type: "string",
      maxLength: 500,
      selectables: [],
      readOnly: true,
      helperText: "",
      error: false,
    },

    {
      name: "Client",
      default: "",
      nullable: true,
      type: "string",
      maxLength: 50,
      selectables: [],
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Building Owner",
      default: "",
      nullable: true,
      type: "string",
      maxLength: 50,
      selectables: [],
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Project Phase",
      default: "Pre-Design",
      nullable: false,
      type: "string",
      maxLength: 50,
      selectables: [
        "Pre-Design",
        "Design",
        "Pre-Construction",
        "Construction",
        "Occupancy and Operations",
      ],
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Administrator",
      default: "",
      nullable: true,
      type: "string",
      maxLength: 50,
      selectables: [],
      readOnly: false,
      helperText: "",
      error: false,
    },
    // {
    //   name: "Project Timezone",
    //   default: "(UTC-05:00) Eastern Standard Time",
    //   nullable: false,
    //   type: "string",
    //   maxLength: 50,
    //   selectables: [
    //     "(UTC-12:00) International Date Line West (e.g., Baker and Howland Islands)",
    //     "(UTC-11:00) Samoa Standard Time",
    //     "(UTC-10:00) Hawaii-Aleutian Standard Time",
    //     "(UTC-09:00) Alaska Standard Time",
    //     "(UTC-08:00) Pacific Standard Time",
    //     "(UTC-07:00) Mountain Standard Time",
    //     "(UTC-06:00) Central Standard Time",
    //     "(UTC-05:00) Eastern Standard Time",
    //     "(UTC-04:00) Atlantic Standard Time",
    //     "(UTC-03:00) Argentina Time (ART)",
    //     "(UTC-02:00) Fernando de Noronha Time (FNT)",
    //     "(UTC-01:00) Cape Verde Time",
    //     "(UTC+00:00) Greenwich Mean Time (GMT) / Coordinated Universal Time  (UTC)",
    //     "(UTC+01:00) Central European Time (CET)",
    //     "(UTC+02:00) Eastern European Time (EET)",
    //     "(UTC+03:00) Moscow Time (MSK)",
    //     "(UTC+04:00) Gulf Standard Time (GST)",
    //     "(UTC+04:30) Afghanistan Time (AFT)",
    //     "(UTC+05:00) Pakistan Standard Time (PKT)",
    //     "(UTC+05:30) Indian Standard Time (IST)",
    //     "(UTC+06:00) Bangladesh Standard Time (BST)",
    //     "(UTC+06:30) Myanmar Standard Time (MMT)",
    //     "(UTC+07:00) Indochina Time (ICT)",
    //     "(UTC+08:00) China Standard Time (CST)",
    //     "(UTC+09:00) Japan Standard Time (JST)",
    //     "(UTC+09:30) Australian Central Standard Time (ACST)",
    //     "(UTC+10:00) Australian Eastern Standard Time (AEST)",
    //     "(UTC+10:30) Lord Howe Standard Time (LHST)",
    //     "(UTC+11:00) Solomon Islands Time (SBT)",
    //     "(UTC+12:00) New Zealand Standard Time (NZST)",
    //     "(UTC+12:45) Chatham Island Standard Time (CHAST)",
    //     "(UTC+13:00) Phoenix Island Time (PHOT)",
    //     "(UTC+14:00) Line Islands Time (LINT)",
    //   ],
    //   readOnly: false,
    //   helperText: "",
    //   error: false,
    // },
    {
      name: "LEED Status",
      default: "",
      nullable: false,
      type: "string",
      maxLength: 50,
      selectables: [
        "N/A",
        "Certified: 40–49 points",
        "Silver: 50–59 points",
        "Gold: 60–79 points",
        "Platinum: 80+ points",
      ],
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "LEED Provider",
      default: "",
      nullable: true,
      type: "string",
      maxLength: 50,
      selectables: [],
      readOnly: false,
      helperText: "",
      error: false,
    },
    {
      name: "Target Closing Date",
      default: "",
      type: "date",
      maxLength: 80,
      selectables: [],
      similair: ["due", "close", "closing date", "target date", "target"],
      helperText: "",
      nullable: false,
      readOnly: false,
      error: false,
    },
  ];

  return schema;
}
